import { ChapterTag, MaskedLines, FadeUp } from "./Reveal";
import { BookButton, WhatsAppButton } from "./CTA";

const STEPS = [
  { n: "01", title: "Inspect", text: "We identify the pest, the source and the conditions contributing to the problem — not just the symptoms." },
  { n: "02", title: "Identify", text: "We determine the treatment approach appropriate for your property, your pest and your family." },
  { n: "03", title: "Treat", text: "We apply the appropriate professional treatment, precisely where it is needed." },
  { n: "04", title: "Prevent", text: "We take practical steps to reduce recurrence — and advise you on keeping it that way." },
];

export const Method = () => (
  <section data-testid="method-section" className="py-24 lg:py-32 bg-cream border-y border-border">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <ChapterTag index="02" label="The Method" />
      <div className="mt-10 max-w-3xl">
        <h2 data-testid="method-headline" className="font-display font-semibold text-charcoal tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
          <MaskedLines lines={[<>Don't just treat the pest.</>, <span className="italic text-wine">Treat the problem.</span>]} />
        </h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border mt-14">
        {STEPS.map((s, i) => (
          <FadeUp key={s.n} delay={i * 0.1} className="bg-cream p-8 lg:p-10 group hover:bg-ivory transition-colors duration-500">
            <span className="font-display italic text-5xl text-gold/70 group-hover:text-gold transition-colors duration-500">{s.n}</span>
            <h3 className="font-display text-2xl font-semibold text-charcoal mt-5 mb-3 uppercase tracking-wide">{s.title}</h3>
            <p className="text-sm text-stone2 leading-relaxed">{s.text}</p>
          </FadeUp>
        ))}
      </div>
      <FadeUp delay={0.3} className="mt-12 flex flex-col sm:flex-row gap-3">
        <BookButton testid="method-book-btn" />
        <WhatsAppButton testid="method-whatsapp-btn" />
      </FadeUp>
    </div>
  </section>
);
